import React from 'react';
import { FadeIn } from './FadeIn';
import { CalendarDays, Sparkles } from 'lucide-react';
export function Transformation() {
  return <section className="bg-amber-light/30 py-24 sm:py-32 relative overflow-hidden" data-id="element-179">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 opacity-10" data-id="element-180">
        <Sparkles className="w-96 h-96 text-amber" data-id="element-181" />
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-8 relative z-10" data-id="element-182">
        <div className="mx-auto max-w-2xl text-center mb-16" data-id="element-183">
          <FadeIn data-id="element-184">
            <h2 className="font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl" data-id="element-185">
              What Changes in 7 Days
            </h2>
          </FadeIn>
        </div>

        <div className="mx-auto max-w-4xl" data-id="element-186">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-187">
            <FadeIn delay={0.1} direction="right" data-id="element-188">
              <div className="bg-white rounded-2xl p-8 shadow-soft h-full border border-amber-light" data-id="element-189">
                <div className="flex items-center gap-4 mb-6" data-id="element-190">
                  <div className="bg-amber-light p-3 rounded-xl" data-id="element-191">
                    <CalendarDays className="h-6 w-6 text-amber" data-id="element-192" />
                  </div>
                  <h3 className="font-serif text-2xl font-bold text-navy" data-id="element-193">
                    By Day 3
                  </h3>
                </div>
                <p className="text-lg text-muted leading-relaxed" data-id="element-194">
                  Your child begins to recognize their own energy needs. The
                  transition from high-energy to focused play becomes smoother.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} direction="left" data-id="element-195">
              <div className="bg-white rounded-2xl p-8 shadow-soft h-full border border-amber-light relative overflow-hidden" data-id="element-196">
                <div className="absolute top-0 right-0 w-2 h-full bg-amber" data-id="element-197" />
                <div className="flex items-center gap-4 mb-6" data-id="element-198">
                  <div className="bg-amber p-3 rounded-xl" data-id="element-199">
                    <Sparkles className="h-6 w-6 text-white" data-id="element-200" />
                  </div>
                  <h3 className="font-serif text-2xl font-bold text-navy" data-id="element-201">
                    By Day 7
                  </h3>
                </div>
                <p className="text-lg text-muted leading-relaxed" data-id="element-202">
                  The "iPad habit" is replaced by a "Play habit," and the
                  post-dinner irritability disappears because they've regulated
                  their nervous system through focused, independent activity
                  instead of passive consumption.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}